import CustomTitle from "../../../components/CustomMiscellaneous/CustomTitle";
import TableView from "../../Common/TableView";
import { NotasCreditoClientesTableConfigs } from "./NotasCreditoClientes.config";
import { generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, NOTAS_CREDITO_CLIENTES_EXTENSION, paginatedGetWithProcessor } from "../../../services/api.service";


export default function NotasCreditoClientes() {

    return (<div>
        <TableView
                title={"Notas de Crédito Clientes"}

            postEntity={genericPost(NOTAS_CREDITO_CLIENTES_EXTENSION)}
            editEntity={genericUpdate(NOTAS_CREDITO_CLIENTES_EXTENSION)}
            deleteEntity={genericDelete(NOTAS_CREDITO_CLIENTES_EXTENSION)}
            addButtonText={"Nova Nota de crédito"}
            tableConfigs={NotasCreditoClientesTableConfigs}
            dataBuildFunction={generalObjectBuilder(NotasCreditoClientesTableConfigs)}
            entityName={"Nota de Crédito Cliente"}
            idProp={"code"}
            reroute={true}
            configMapKey={"notas-credito-clientes"}
        />
    </div>)

}

